import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "../axios";
import { showDate, todayKey } from "../components/ShowPieces";

function TicketsScreen() {
  const [searchParams] = useSearchParams();
  const focus = searchParams.get("event");
  const [events, setEvents] = useState(null);

  useEffect(() => {
    axios
      .get("/api/users/events/")
      .then(({ data }) => setEvents(data))
      .catch(() => setEvents([]));
  }, []);

  const today = todayKey();
  const upcoming = (events || []).filter((item) => item.date >= today);

  useEffect(() => {
    if (!focus || !events) {
      return;
    }
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    document.getElementById(`ticket-event-${focus}`)?.scrollIntoView({
      behavior: reduce ? "auto" : "smooth",
      block: "start",
    });
  }, [focus, events]);

  return (
    <div className="beach">
      <section className="site-section">
        <div className="site-wrap">
          <article className="company-card company-card-wide">
            <header className="company-card-head">
              <p className="site-kicker">Tickets</p>
              <h2>Spectator tickets</h2>
            </header>
            <div className="company-card-body">
              <p className="company-lead">
                Admission is sold for each day of the show. A spectator can also buy a seat at that day's VIP luncheon.
              </p>
              {events === null ? (
                <p>Loading the shows.</p>
              ) : upcoming.length === 0 ? (
                <p>The next show will appear here.</p>
              ) : (
                <div className="ticket-board">
                  {upcoming.map((item) => {
                    const lunches = item.lunches || [];
                    return (
                      <article
                        key={item.id}
                        id={`ticket-event-${item.id}`}
                        className={String(item.id) === String(focus) ? "is-on" : ""}
                      >
                        <div>
                          <p className="ticket-date">{showDate(item.date)}</p>
                          <h3>{item.title}</h3>
                          {lunches.length > 0 ? (
                            <div className="ticket-lunch">
                              <p className="ticket-optional">Optional</p>
                              <ul>
                                {lunches.map((lunch) => (
                                  <li key={lunch.id}>
                                    <strong>{lunch.title}</strong>
                                    {lunch.hosted ? ` · Hosted by ${lunch.hosted}` : ""}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ) : null}
                        </div>
                        <div className="ticket-actions">
                          <Link className="btn btn-site" to={`/show/${item.id}?spectator=1`}>
                            Get tickets
                          </Link>
                          <Link className="btn btn-site-quiet" to={`/show/${item.id}`}>
                            See this show
                          </Link>
                        </div>
                      </article>
                    );
                  })}
                </div>
              )}
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}

export default TicketsScreen;
